/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Loud_Lion_TripInputs */

const en_full_loud_lion_trip = /** @type {(inputs: Full_Loud_Lion_TripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surveys`)
};

const de_full_loud_lion_trip = /** @type {(inputs: Full_Loud_Lion_TripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfragen`)
};

/**
* | output |
* | --- |
* | "Surveys" |
*
* @param {Full_Loud_Lion_TripInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_loud_lion_trip = /** @type {((inputs?: Full_Loud_Lion_TripInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Loud_Lion_TripInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_loud_lion_trip(inputs)
	return de_full_loud_lion_trip(inputs)
});